import { FC } from 'react';
import { Stack, Button, Typography } from '@mui/material';
import { useRouter } from '@cvt/routing';


export const MarketingButtons: FC = () => {
  const router = useRouter();
  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent="center"
      sx={{
        mt: 2,
        py: 2,
        px: { xs: 1, sm: 2 },
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.08)',
        border: '1px solid rgb(254, 238, 237)',
      }}
    >
      <Stack direction="column" spacing={1} alignItems="center">
        <Typography variant="body2" align="center">
          Start your own LGCY now. A beautiful way to remember your journey of love.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => router.tributes.create.details.go()}
        >
          Create Your Own LGCY
        </Button>
      </Stack>
      <Stack direction="column" spacing={1} alignItems="center">
        <Typography variant="body2" align="center">
          Know someone who has recently felt the loss of a loved one? Gift them a LGCY.
        </Typography>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => router.gift.create.go()}
        >
          Gift a LGCY
        </Button>
      </Stack>
    </Stack>
  );
};